export default "__VITE_ASSET__Ck7lRi7A__"